var map = {
	"./account.svg": "ef22",
	"./all.svg": "6d66",
	"./apply.svg": "74f1",
	"./artboard.svg": "cc51",
	"./base-use.svg": "014e",
	"./bowl.svg": "2521",
	"./building.svg": "8c51",
	"./calendar.svg": "0870",
	"./car.svg": "ec2f",
	"./clean.svg": "1bce",
	"./coin.svg": "a27e",
	"./community.svg": "aeff",
	"./computer.svg": "8c98",
	"./download.svg": "4daeb",
	"./egg.svg": "abd6",
	"./file.svg": "b8b2",
	"./file1.svg": "6006",
	"./flask.svg": "5155a",
	"./hashtag.svg": "a9bf",
	"./headset_mic.svg": "c978",
	"./home.svg": "6bbe",
	"./location.svg": "1c50",
	"./menu.svg": "bd3d",
	"./message.svg": "47ff",
	"./plug.svg": "6151",
	"./profile-line.svg": "b407",
	"./quota.svg": "2908",
	"./radio.svg": "d8dc",
	"./reading.svg": "3a2e",
	"./recycle.svg": "19a9",
	"./seedling.svg": "068c",
	"./send.svg": "94d0",
	"./service.svg": "4e04",
	"./settings.svg": "3fc8",
	"./signpost.svg": "4873",
	"./sofa.svg": "c84f",
	"./sort.svg": "e528",
	"./stairs.svg": "ddda",
	"./standard.svg": "b465",
	"./star.svg": "708a",
	"./star_border.svg": "54a8",
	"./submit.svg": "1359",
	"./t-shirt.svg": "dd9c",
	"./task.svg": "771b",
	"./time.svg": "3add",
	"./top.svg": "deee",
	"./training.svg": "a9c4",
	"./tree.svg": "93cd",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";